import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { Box, CloseButton, Flex, IconButton } from "pcln-design-system";
import styled_components from "styled-components";
import pcln_popover from "pcln-popover";
import { ChatbotDataContext } from "../../../context/ChatbotDataContext.js";
import RealtimeIcon from "../../../svgs/RealtimeIcon.js";
import RealtimeToolTipInfo from "../../../Voice/RealtimeToolTipInfo.js";
import MicIcon from "../../../svgs/MicIcon.js";
import { useRealTimeContext } from "../../../hooks/useRealTimeContext.js";
import RealtimeInfoModal from "./RealtimeInfoModal.js";
const MicContainer = /*#__PURE__*/ styled_components(Box).withConfig({
    displayName: "VoiceControlButton__MicContainer"
})([
    "height:49px;width:49px;z-index:1000;"
]);
const PopoverContent = /*#__PURE__*/ styled_components(Flex).withConfig({
    displayName: "VoiceControlButton__PopoverContent"
})([
    "z-index:1000;"
]);
const VoiceControlButton = ({ isExpandableTextArea })=>{
    const { enableVoiceTooltip } = useContext(ChatbotDataContext);
    const { setStartRealTime, isRealtime } = useRealTimeContext();
    const [isMounted, setIsMounted] = useState(false);
    const [showRealTimeInfoModal, setShowRealTimeInfoModal] = useState(false);
    const [showVoiceTooltip, setShowVoiceTooltip] = useState(true);
    useEffect(()=>{
        if ('undefined' != typeof localStorage && localStorage.getItem) {
            const userClosedTooltip = localStorage.getItem('userClosedVoiceModeTooltip');
            'true' !== userClosedTooltip ? setShowVoiceTooltip(true) : setShowVoiceTooltip(false);
        }
    }, []);
    useEffect(()=>{
        if (showRealTimeInfoModal) {
            const body = document.querySelector("body");
            body.style.setProperty('position', 'static', 'important');
        }
    }, [
        showRealTimeInfoModal
    ]);
    useEffect(()=>{
        setIsMounted(true);
    }, []);
    function handleStartRealTime() {
        setStartRealTime(true);
    }
    function handleShowRealTimeInfoModal(value) {
        setShowRealTimeInfoModal(value);
    }
    function closeTooltip() {
        setShowVoiceTooltip(false);
        if ('undefined' != typeof localStorage && localStorage.setItem) localStorage.setItem('userClosedVoiceModeTooltip', 'true');
    }
    if (!isMounted) return null;
    if (isExpandableTextArea) return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(pcln_popover, {
                renderContent: ({ handleClose })=>/*#__PURE__*/ jsxs(PopoverContent, {
                        id: "voice-mode-tooltip",
                        p: 2,
                        style: {
                            pointerEvents: 'auto'
                        },
                        "data-testid": "voice-tooltip",
                        children: [
                            /*#__PURE__*/ jsx(Box, {
                                height: "40px",
                                width: "40px",
                                m: 2,
                                children: /*#__PURE__*/ jsx(RealtimeIcon, {})
                            }),
                            /*#__PURE__*/ jsx(RealtimeToolTipInfo, {
                                isRealtime: isRealtime,
                                handleShowRealTimeInfoModal: handleShowRealTimeInfoModal
                            }),
                            /*#__PURE__*/ jsx(Box, {
                                children: /*#__PURE__*/ jsx(CloseButton, {
                                    "data-testid": "tooltip-close-button",
                                    onClick: handleClose
                                })
                            })
                        ]
                    }),
                idx: "voiceModeTooltip",
                zIndex: 1000,
                placement: "top",
                ariaLabel: "Voice Mode Information",
                width: 310,
                stopPropagation: false,
                toggleIsOpenOnClick: false,
                openOnHover: false,
                openOnFocus: false,
                openOnMount: false,
                onClose: closeTooltip,
                isOpen: showVoiceTooltip && enableVoiceTooltip && !showRealTimeInfoModal,
                children: /*#__PURE__*/ jsx(IconButton, {
                    onClick: handleStartRealTime,
                    "data-testid": "real-time-record-button",
                    icon: /*#__PURE__*/ jsx(RealtimeIcon, {
                        size: 'sm'
                    })
                })
            }),
            /*#__PURE__*/ jsx(RealtimeInfoModal, {
                setShowRealTimeInfoModal: setShowRealTimeInfoModal,
                setShowVoiceTooltip: setShowVoiceTooltip,
                showRealTimeInfoModal: showRealTimeInfoModal
            })
        ]
    });
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(pcln_popover, {
                renderContent: ({ handleClose })=>/*#__PURE__*/ jsxs(PopoverContent, {
                        id: "voice-mode-tooltip",
                        p: 2,
                        style: {
                            pointerEvents: 'auto'
                        },
                        "data-testid": "voice-tooltip",
                        children: [
                            /*#__PURE__*/ jsx(Box, {
                                height: "40px",
                                width: "40px",
                                m: 2,
                                children: isRealtime ? /*#__PURE__*/ jsx(RealtimeIcon, {}) : /*#__PURE__*/ jsx(MicIcon, {
                                    width: '30'
                                })
                            }),
                            /*#__PURE__*/ jsx(RealtimeToolTipInfo, {
                                isRealtime: isRealtime,
                                handleShowRealTimeInfoModal: handleShowRealTimeInfoModal
                            }),
                            /*#__PURE__*/ jsx(Box, {
                                children: /*#__PURE__*/ jsx(CloseButton, {
                                    "data-testid": "tooltip-close-button",
                                    onClick: handleClose
                                })
                            })
                        ]
                    }),
                idx: "voiceModeTooltip",
                zIndex: 1000,
                placement: "top",
                ariaLabel: "Voice Mode Information",
                width: isRealtime ? 310 : 290,
                stopPropagation: false,
                toggleIsOpenOnClick: false,
                openOnHover: false,
                openOnFocus: false,
                openOnMount: false,
                onClose: closeTooltip,
                isOpen: showVoiceTooltip && enableVoiceTooltip && !showRealTimeInfoModal,
                children: /*#__PURE__*/ jsx(MicContainer, {
                    children: /*#__PURE__*/ jsx(IconButton, {
                        onClick: handleStartRealTime,
                        "data-testid": "real-time-record-button",
                        icon: /*#__PURE__*/ jsx(RealtimeIcon, {
                            size: 'md'
                        })
                    })
                })
            }),
            /*#__PURE__*/ jsx(RealtimeInfoModal, {
                setShowRealTimeInfoModal: setShowRealTimeInfoModal,
                setShowVoiceTooltip: setShowVoiceTooltip,
                showRealTimeInfoModal: showRealTimeInfoModal
            })
        ]
    });
};
const VoiceControlButton_VoiceControlButton = VoiceControlButton;
export { VoiceControlButton_VoiceControlButton as default };
